export default "__VITE_ASSET__egHAE0Qe__"